import {
  FalseReasonType,
  ProgramsType,
  type JobProgramResponseType
} from '@shared/generated';
import { isFalseReasonType } from '@shared/utils/typeGuards';
import { useI18n } from 'vue-i18n';

export const getIneligilityReasonTranslation = (
  reasonKey: FalseReasonType,
  reasonValue: string | boolean,
  program: ProgramsType
): string => {
  const { t } = useI18n();
  return t(`common_job.ineligible.reasons.${reasonKey}`, {
    program: t(`common_programs.name.${program}.long_form`),
    reason: reasonValue
  });
};

export const useIneligibilityReasons = (
  jobPrograms: JobProgramResponseType[]
): string[] => {
  const ineligibilityReasons: string[] = [];

  for (const program of jobPrograms) {
    if (
      !program.ineligibility_info ||
      !program.ineligibility_info.false_reasons
    ) {
      continue;
    }

    Object.keys(program.ineligibility_info.false_reasons).forEach((key) => {
      if (!isFalseReasonType(key)) {
        return;
      }
      const ineligibilityDetails =
        program.ineligibility_info?.false_reasons?.[key];
      if (!ineligibilityDetails) {
        return;
      }
      ineligibilityReasons.push(
        ineligibilityDetails === true
          ? getIneligilityReasonTranslation(
              key,
              ineligibilityDetails,
              program.program.key
            )
          : ineligibilityDetails
      );
    });
  }
  return ineligibilityReasons;
};
